import React, { memo } from 'react';
import Divider from '@Components/Common/Divider';
import SpaceWrapper from '@Components/Layout/SpaceWrapper';
import Stack from '@Components/Layout/Stack';
import useSystemColorScheme from '@Hooks/useSystemColorScheme';
import useSystemIsLightMode from '@Hooks/useSystemIsLightMode';

function UseSystemColorSchemeDemo(): React.ReactElement {
  /* States */
  const scheme = useSystemColorScheme();
  const isLightMode = useSystemIsLightMode();

  /* Main */
  return (
    <SpaceWrapper padding={24}>
      <Stack divider={<Divider />}>
        <div>current system color scheme: {scheme}</div>
        <div>is system in light mode? {isLightMode ? 'true' : 'false'}</div>
      </Stack>
    </SpaceWrapper>
  );
}

export default memo(UseSystemColorSchemeDemo);
